var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkemptyversionhistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 85,
    viewBox: "0 0 150 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.713 11C147.185 11 150 13.8247 150 17.3091C150 20.7935 147.185 23.6181 143.713 23.6181H107.784C111.257 23.6181 114.072 26.4428 114.072 29.9272C114.072 33.4116 111.257 36.2363 107.784 36.2363H127.545C131.017 36.2363 133.832 39.0609 133.832 42.5453C133.832 46.0298 131.017 48.8544 127.545 48.8544H118.407C114.028 48.8544 110.479 51.6791 110.479 55.1635C110.479 57.4864 112.275 59.5894 115.868 61.4726C119.341 61.4726 122.156 64.2972 122.156 67.7816C122.156 71.266 119.341 74.0907 115.868 74.0907H41.3174C37.8449 74.0907 35.0299 71.266 35.0299 67.7816C35.0299 64.2972 37.8449 61.4726 41.3174 61.4726H6.28743C2.81498 61.4726 0 58.6479 0 55.1635C0 51.6791 2.81498 48.8544 6.28743 48.8544H42.2156C45.688 48.8544 48.503 46.0298 48.503 42.5453C48.503 39.0609 45.688 36.2363 42.2156 36.2363H19.7605C16.288 36.2363 13.4731 33.4116 13.4731 29.9272C13.4731 26.4428 16.288 23.6181 19.7605 23.6181H55.6886C52.2162 23.6181 49.4012 20.7935 49.4012 17.3091C49.4012 13.8247 52.2162 11 55.6886 11H143.713ZM143.713 36.2363C147.185 36.2363 150 39.0609 150 42.5453C150 46.0298 147.185 48.8544 143.713 48.8544C140.24 48.8544 137.425 46.0298 137.425 42.5453C137.425 39.0609 140.24 36.2363 143.713 36.2363Z",
    fill: "#2B2E31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 3H86.895C88 3 88.5938 4.07143 90 5.5C92.9454 9.60315 100 16 105 21V75.381C105 79.5905 101.644 83 97.5 83H52.5C48.3562 83 45 79.5905 45 75.381V10.619C45 6.40952 48.3562 3 52.5 3Z",
    fill: "#BFC4CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0002 3.40916L88.0003 17.4981C87.9927 19.5188 89.743 21.136 91.7572 21.146L105 21",
    fill: "#AFB3BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 52.9236H90.5H53Z",
    fill: "#D5DDEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52.9236H90.5",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 58.9048H90.5H53Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58.9048H90.5",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 67H81H53Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67H81",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 73H70H53Z",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73H70",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74 73H81H74Z",
    fill: "#D5DDEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73H81",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 47H90.5H53Z",
    fill: "#D5DDEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47H90.5",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 41.3048H70.5849H53Z",
    fill: "#D5DDEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41.3048H70.5849",
    stroke: "#91979D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6198 21.9297C73.6198 23.413 73.1799 24.8631 72.3558 26.0965C71.5317 27.3298 70.3604 28.2911 68.99 28.8588C67.6196 29.4264 66.1116 29.575 64.6568 29.2856C63.202 28.9962 61.8656 28.2819 60.8168 27.233C59.7679 26.1841 59.0536 24.8477 58.7642 23.3929C58.4748 21.938 58.6234 20.43 59.191 19.0596C59.7587 17.6891 60.7199 16.5178 61.9533 15.6937C63.1866 14.8696 64.6366 14.4297 66.1199 14.4297C68.1083 14.4319 70.0147 15.2228 71.4207 16.6288C72.8267 18.0349 73.6175 19.9412 73.6198 21.9297ZM69.0824 22.903L66.9532 21.4839V17.763C66.9532 17.542 66.8655 17.33 66.7092 17.1738C66.5529 17.0175 66.3409 16.9297 66.1199 16.9297C65.8989 16.9297 65.687 17.0175 65.5307 17.1738C65.3744 17.33 65.2866 17.542 65.2866 17.763V21.9297C65.2866 22.0668 65.3204 22.2019 65.3851 22.3228C65.4498 22.4438 65.5434 22.5469 65.6574 22.623L68.1574 24.2897C68.3413 24.4123 68.5663 24.4569 68.7831 24.4136C68.9999 24.3704 69.1905 24.2427 69.3132 24.0589C69.4359 23.875 69.4804 23.6499 69.4372 23.4331C69.3939 23.2164 69.2662 23.0257 69.0824 22.903Z",
    fill: "#5E6778"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5001 22.7628L54.6088 24.9062L56.7188 22.7628",
    stroke: "#91979D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6094 25.0385L54.6094 22.226C54.6094 16.0123 59.6456 10.9773 65.8592 10.9773C72.0728 10.9773 77.1089 16.0135 77.1089 22.2273C77.1089 28.441 72.0728 33.4773 65.8592 33.4773C62.3092 33.4773 59.1468 31.8285 57.0856 29.2585",
    stroke: "#91979D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkemptyversionhistory);
export default __webpack_public_path__ + "static/media/darkemptyversionhistory.18aa5137cdb308c7df1472452f3049eb.svg";
export { ForwardRef as ReactComponent };